export default __webpack_public_path__ + "static/media/plain-sticker-t.257bf4ff.png";